import SiteLayout from "@/components/SiteLayout";
import Hero from "@/pages/home/Hero";
import FeaturedStories from "@/pages/home/FeaturedStories";
import WhatIs from "@/pages/home/WhatIs";
import Ecosystem from "@/pages/home/Ecosystem";
import Sponsor from "@/pages/home/Sponsor";
import FoundingPartnersHome from "@/pages/home/FoundingPartnersHome";
import Community from "@/pages/home/Community";
import FinalNewsletter from "@/pages/home/FinalNewsletter";
import InstagramBlock from "@/components/InstagramBlock";
import Container from "@/components/editorial/Container";
import Eyebrow from "@/components/editorial/Eyebrow";
import { STORIES } from "@/data/content";

const OG_IMAGE = STORIES[0].image;
const SITE_URL = "https://mujeres-motor.com";
const TITLE =
  "Mujeres Motor · Historias reales. Comunidad viva. Impacto visible.";
const DESC =
  "La plataforma documental que visibiliza a las mujeres que están moviendo México. Historias, podcast, eventos y comunidad.";

export default function Home() {
  return (
    <SiteLayout transparentHeader>
      <></>

      <Hero />
      <FeaturedStories />
      <WhatIs />
      <Ecosystem />
      <Sponsor />
      <FoundingPartnersHome />
      <Community />

      <section data-testid="home-instagram-section" className="bg-cream py-20 md:py-24 border-t border-charcoal/5">
        <Container>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
            <div>
              <Eyebrow tone="terracotta" className="mb-4 block">@mujeres_motor</Eyebrow>
              <h2 className="font-serif font-light text-3xl md:text-4xl text-charcoal max-w-xl leading-tight">
                Detrás de cámaras y <span className="italic">momentos editoriales.</span>
              </h2>
            </div>
            <a
              href="https://www.instagram.com/mujeres_motor"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs uppercase tracking-[0.22em] text-terracotta hover:text-[#A64826] inline-flex items-center gap-1.5 self-start md:self-auto"
            >
              Síguenos en Instagram →
            </a>
          </div>
          <InstagramBlock />
        </Container>
      </section>

      <FinalNewsletter />
    </SiteLayout>
  );
}
